const DEFAULT_AUTHENTICATED_PATH = '/project';

const VALID_REDIRECT_PATHS = new Set(['/', '/change-password', '/project', '/project/create']);
const VALID_REDIRECT_PATTERNS = [
  /^\/project\/\d+$/,
  /^\/project\/\d+\/(createSubProject|config|prompt|integrations|multimedia|demo-chat|users|clone)$/,
  /^\/project\/\d+\/(config|prompt|multimedia|propiedades)\/\d+$/,
];

function isValidRedirectPath(pathname: string): boolean {
  return VALID_REDIRECT_PATHS.has(pathname) || VALID_REDIRECT_PATTERNS.some((pattern) => pattern.test(pathname));
}

export const getSafeRedirectPath = (redirectPath: string | null, fallbackPath = DEFAULT_AUTHENTICATED_PATH): string => {
  if (!redirectPath) {
    return fallbackPath;
  }

  try {
    const url = new URL(redirectPath, window.location.origin);
    if (url.origin !== window.location.origin || !isValidRedirectPath(url.pathname)) {
      return fallbackPath;
    }

    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return fallbackPath;
  }
};

export const buildLoginRedirectPath = (pathname: string, search: string): string => {
  const redirectPath = `${pathname}${search}`;
  return `/login?redirect=${encodeURIComponent(redirectPath)}`;
};
